import React from "react";

const ITEMS = [
  "350 GSM HEAVYWEIGHT HOODIES",
  "MADE IN LONDON",
  "FREE UK DELIVERY OVER £75",
  "14-DAY RETURNS",
  "SUBSTANCE OVER HYPE",
  "START WITH WHAT MATTERS",
];

function Row() {
  return (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display font-bold uppercase tracking-tight text-xl md:text-3xl px-6 md:px-10 whitespace-nowrap text-bone/85">
            {item}
          </span>
          <span className="w-2.5 h-2.5 rotate-45 bg-ember shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="border-y border-white/10 bg-coal/60 py-5 md:py-6 overflow-hidden" data-testid="editorial-marquee-container">
      <div className="marquee-track">
        <Row />
      </div>
    </div>
  );
}
